import React from "react";
import { MassChange } from "./MassChange";
import { Space, Tabs, TabsProps } from 'antd'
import { translate } from '../../../core'
import { InfoTooltip } from '../../../core/component'
import { ItemBulkUpdateHistoryList } from '../../inventory/component/ItemBulkUpdateHistoryList'

const MassChangeMain: React.FC = () => {
  const items: TabsProps['items'] = [
    {
      key: 'mass_changes',
      label: (
        <Space size={4}>
          {translate('mass_changes')}
          <InfoTooltip contentKey='massChange.list' placement='right' />
        </Space>
      ),
      children: <MassChange/>,
    },
    {
      key: 'history',
      label: translate('history'),
      children: <ItemBulkUpdateHistoryList/>
    },
  ]
  return <Tabs
    items={items}
    size='large'
  />
};

export default MassChangeMain;
